import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
import { testimonials } from '../data/testimonials';
function Stars({
  size = 'h-5 w-5'
}: {
  size?: string;
}) {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-302" data-mp="3fycplkeko19q">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-amber-400 text-amber-400`} aria-hidden="true" data-id="element-303" data-mp="3b0ax68v9apll" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-canvas px-5 py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-304" data-mp="31yuxow5zc7w5">
      <div className="mx-auto max-w-5xl" data-id="element-305" data-mp="2x006p6xuzd0y">
        <h2 id="testimonials-title" className="text-center font-display text-4xl font-bold uppercase leading-tight text-navy-900 sm:text-5xl" data-id="element-306" data-mp="2x2w2opq5brmr">
          What other dentists are saying
        </h2>
        <div className="mt-5 flex flex-col items-center gap-2" data-id="element-307" data-mp="qac1oyvee8zv">
          <div className="flex items-center gap-3" data-id="element-308" data-mp="qb50ndo47u7g">
            <span className="font-display text-5xl font-bold text-navy-900" data-id="element-309" data-mp="h5f03oky0129">4.9</span>
            <div data-id="element-310" data-mp="m4rnqbjn1c5w">
              <Stars size="h-6 w-6" data-id="element-311" data-mp="m5b3pmpq9qha" />
              <p className="text-sm font-semibold text-muted" data-id="element-312" data-mp="m6cgpwqb0n1n">out of 5</p>
            </div>
          </div>
          <p className="max-w-md text-center text-lg text-muted" data-id="element-313" data-mp="79v6j8tupego">
            Join dentists who are using structured risk-review tools to strengthen their implant planning process.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-314" data-mp="zyscccgvlisj">
          {testimonials.map((t, i) => <li key={t.name} className={`flex flex-col rounded-3xl bg-white p-6 ring-1 ring-navy-900/10 ${i === testimonials.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-315" data-mp="14xde4gbs0aj3" data-mpi={i}>
              <Stars data-id="element-316" data-mp="1iusay64czkl3" />
              <blockquote className="mt-4 text-lg leading-relaxed text-ink" data-id="element-317" data-mp="1iuiga58dcp92">"{t.quote}"</blockquote>
              <div className="mt-auto flex items-center gap-4 pt-6" data-id="element-318" data-mp="1nmscg302uljs">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-radar" loading="lazy" data-id="element-319" data-mp="1xiirct2b5eh4" />
                <div data-id="element-320" data-mp="1ofzqgei31bxi">
                  <p className="flex items-center gap-1.5 font-semibold text-navy-900" data-id="element-321" data-mp="1ofhpx5oe0bjs">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-radar-deep" aria-label="Verified" data-id="element-322" data-mp="1jkkdrpvt9m2o" />
                  </p>
                  <p className="text-sm text-muted" data-id="element-323" data-mp="19sofoetq5vyg">{t.country}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <SectionCta label="I want to build my Implant Risk Radar™" data-id="element-324" data-mp="14tv10j2pbywp" />
      </div>
    </section>;
}